import wire from '../wire';
import template from './embed.html';
import EmbedController from './embed';

let module = wire('embed', template, EmbedController, 'EmbedController', '/embed?channel_id');

require('./embed-directive');

export default module;



// WEBPACK FOOTER //
// ./app/pages/embed/_index.js